import { Component, ChangeDetectorRef, Input, Output, EventEmitter } from '@angular/core';
import { HEC_CONSTANTS } from '../../../../../../../src/app/utilities/constants';

@Component({
	selector: 'kt-terms-conditions',
	templateUrl: './terms-conditions.component.html',
	styleUrls: ['./terms-conditions.component.scss']
})
export class TermsConditionsComponent {
	@Input('termsAndConditions') termsAndConditions;
	@Output() termsAccepted = new EventEmitter<void>();
	public isAccepted: boolean = false;
	public isError: boolean = false;
	public alertType: string = '';
	public errorMsg: string = '';
	constructor(private cdr: ChangeDetectorRef) {

	}
	ngOnInit(): void {
	}

	onCheckBoxChange = (event) => {
		this.isAccepted = event;
	};

	onProceedClick = () => {
		if (this.isAccepted) {
			this.isError = false;
			this.termsAccepted.emit();
		}
		else {
			this.isError = true;
			this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
			this.errorMsg = HEC_CONSTANTS.PUCA_CONSTANTS.TERM_AND_CONDITION_ERROR;
			this.cdr.detectChanges();
		}
	};
}
